import { initApiRequest } from 'lib/api-request';
import { TrainingReportInterface } from 'pages/private/RoutineManagement/Report/Schema';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { adminApi } from './admin.api';

// --- Interfaces ---

export interface AppConfigInterface {
  id?: string | number;
  domain_name?: string;
  address: string;
  phone_number: string;
  logo: any;
  background_image: any;
  register_image: any;
  login_image: any;
  title: string;
}

export interface UpdatemarksInterface {
  newId: string;
  obtain_marks: any;
}

const {
  CreateAppConfig,
  UpdateAppConfig,
  DeleteAppConfig,
  GetAppConfigList,
  GetAppConfigByDomain,
  UpadateMark,
  BulkCreateTrainee,
  GetUserTrainee,
  activeRoutine,
  getRoutineReportById,
  getlistTraining,
  getTraineeProfileList,
  getTraineeAttendance,
  getRoutineCourseDetail,
  getAllRoutineList,
  getAllActiveCourseList,
  getAllActiveTrainingList,
  getAvailableUserList,
  addImage,
  addMultipleImage,
  assignImageToRoutine,
  saveRoutineReport,
  getAdminList,
  getRoutineDetails
} = adminApi;

// --- Hooks ---

/**
 * GET: List all App Configurations
 */


export const useSaveandUpadateRoutineReport = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [saveRoutineReport.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: saveRoutineReport,
        requestData: requestData?.payload,
        pathVariables: { id: requestData?.routineId }
      });
    },
    onSuccess(res) {
      if (res?.data?.code == 200) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || 'Something went wrong');
      }
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message || err?.data?.message || 'Something went wrong');
    }
  });
};

export const useAddImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [addImage.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: addImage,
        requestData
      });
    },
    onSuccess(res) {
      if (res?.data.code == 200) {

      } else {
      }
    },
    onError: (err: any) => {
    }
  });
};


export const useAddMultipleImages = () => {
  return useMutation({
    mutationKey: [addMultipleImage.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: addMultipleImage,
        requestData
      });
    }
  });
};

export const useAssignImageToRoutine = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [assignImageToRoutine.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: assignImageToRoutine,
        requestData
      });
    },
    onSuccess(res) {
      if (res?.data.code == 200) {

      } else {
      }
    },
    onError: (err: any) => {
    }
  });
};

export const useBulkCreateTrainee = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [BulkCreateTrainee.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: BulkCreateTrainee,
        requestData
      });
    },
    onSuccess(res) {
      if (res?.data.code == 200) {
        toast.success(res.data.message);
        queryClient.invalidateQueries([GetUserTrainee.actionName]);
      } else {
        toast.error(res?.data?.message);
      }
    },
    onError: (err: any) => {
      toast.error(err.error?.data.message);
    }
  });
};
export const useUpdateMarks = (newId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UpadateMark.actionName],
    mutationFn(requestData: UpdatemarksInterface) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: UpadateMark,
        requestData: { obtain_marks: requestData?.obtain_marks },
        pathVariables: { newId }
      });
    },
    onSuccess(res) {
      if (res?.data.code == 200) {
        toast.success(res.data.message);
      } else {
        toast.error(res?.data?.message);
      }
    },
    onError: (err: any) => {
      toast.error(err.error?.data.message);
    }
  });
};
export const useGetAppConfigList = () => {
  return useQuery({
    queryKey: [GetAppConfigList.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<AppConfigInterface[]>>({
        apiDetails: GetAppConfigList
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};

export const useGetRoutineDetails = (routineId: string) => {
  return useQuery({
    queryKey: [getRoutineDetails.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getRoutineDetails,
        pathVariables: { routineId }
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};


export const useGetAllRoutineList = () => {
  return useQuery({
    queryKey: [getAllRoutineList.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getAllRoutineList
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};

export const useGetAllActiveCourseList = () => {
  return useQuery({
    queryKey: [getAllActiveCourseList.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getAllActiveCourseList
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};

export const useGetAllActiveTrainingList = () => {
  return useQuery({
    queryKey: [getAllActiveTrainingList.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getAllActiveTrainingList,
        params: { pageNo: 1, pageSize: 999999 }
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};

export const useGetAutoCompleteTrainingList = () => {
  return useMutation({
    mutationKey: [getAllActiveTrainingList.actionName, 'autocomplete'],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getAllActiveTrainingList,
        params: { ...requestData }
      });
    }
  });
};

export const useGetRoutineCourseDetailById = (routineId: string, enabled?: boolean) => {
  return useQuery({
    queryKey: [getRoutineCourseDetail.actionName, routineId],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getRoutineCourseDetail,
        pathVariables: { routineId }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};

export const useGetTraineeProfileList = (id: number, enabled: boolean) => {
  return useQuery({
    queryKey: [getTraineeProfileList.actionName, id],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any[]>>({
        apiDetails: getTraineeProfileList,
        params: { routineId: id }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};

export const useGetActiveRoutine = (filter: string, enabled: boolean = false) => {
  return useQuery({
    queryKey: [activeRoutine.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<unknown[]>>({
        apiDetails: activeRoutine,
        params: { filter: filter }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};

/**
 * GET: Get App Configuration by Domain
 */
export const useGetAppConfigByDomain = (domainName: string, enabled?: boolean) => {
  return useQuery({
    queryKey: [GetAppConfigByDomain.actionName, domainName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<AppConfigInterface>>({
        apiDetails: GetAppConfigByDomain,
        params: { domainName: domainName } // Assuming backend expects ?domain=...
      });
    },
    enabled: !!domainName && enabled,
    select(data) {
      return data?.data.data;
    }
  });
};

/**
 * POST: Create App Configuration
 */
export const useCreateAppConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [CreateAppConfig.actionName],
    mutationFn(requestData: AppConfigInterface) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: CreateAppConfig,
        requestData: requestData
      });
    },
    onSuccess(res) {
      if (res?.data.code === 200 || res?.data.code === 201) {
        toast.success(res.data.message || 'Created successfully');
        queryClient.invalidateQueries([GetAppConfigList.actionName]);
      } else {
        toast.error(res?.data?.message);
      }
    },
    onError: (err: any) => {
      toast.error(err.error?.data.message || 'Something went wrong');
    }
  });
};

/**
 * PATCH: Update App Configuration
 */
export const useUpdateAppConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UpdateAppConfig.actionName],
    mutationFn(requestData: Partial<AppConfigInterface>) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: UpdateAppConfig,
        requestData: requestData,
        pathVariables: { id: requestData?.id }
      });
    },
    onSuccess(res) {
      if (res?.data.code === 200) {
        toast.success(res.data.message || 'Updated successfully');
        queryClient.invalidateQueries([GetAppConfigList.actionName]);
      } else {
        toast.error(res?.data?.message);
      }
    },
    onError: (err: any) => {
      toast.error(err.error?.data.message || 'Update failed');
    }
  });
};

export const useGetAvailableLectureList = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [getAvailableUserList.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getAvailableUserList,
        params: { ...requestData }
      });
    },

  });
};

export const useGetAutoCompleteAdminList = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [getAdminList.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: getAdminList,
        params: { ...requestData }
      });
    },

  });
};

/**
 * DELETE: Delete App Configuration
 */
export const useDeleteAppConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DeleteAppConfig.actionName],
    mutationFn(id: string | number) {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: DeleteAppConfig,
        pathVariables: { id }
      });
    },
    onSuccess(res) {
      if (res?.data.code === 200) {
        toast.success(res.data.message || 'Deleted successfully');
        queryClient.invalidateQueries([GetAppConfigList.actionName]);
      } else {
        toast.error(res?.data?.message);
      }
    },
    onError: (err: any) => {
      toast.error(err.error?.data.message || 'Deletion failed');
    }
  });
};

export const useGetRoutineReportById = (routineId: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: [getRoutineReportById.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<TrainingReportInterface>>({
        apiDetails: getRoutineReportById,
        pathVariables: { routineId: routineId }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};

export const useGetTraineeAttendanceByRoutineId = (
  routineId: number | undefined,
  enabled: boolean
) => {
  return useQuery({
    queryKey: [getTraineeAttendance.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<TrainingReportInterface>>({
        apiDetails: getTraineeAttendance,
        params: { routineId: routineId }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};

export const useGetTrainingList = (search?: string, enabled?: boolean) => {
  return useQuery({
    queryKey: [getlistTraining.actionName, search],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any[]>>({
        apiDetails: getlistTraining
      });
    },
    select(data) {
      return data?.data.data ?? [];
    },
    enabled
  });
};
